import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from '~/components/atoms/button/button.module.scss';
import instantStyles from './InstantSearchAllResults.module.scss';

interface IInstantSearchAllResultsProps {
    openFullSERP: () => void;
}

const InstantSearchAllResults: React.FC<IInstantSearchAllResultsProps> = ({ openFullSERP }) => {
    return (
        <div className={instantStyles.instantSearchAllResults} data-testid="instantsearch-module-searchallresults">
            <button onClick={openFullSERP} className={classNames(styles.button, instantStyles.instantAllButton)}>
                <FormattedMessage id="instant_search_all_results" defaultMessage="Všechny výsledky" />
            </button>
        </div>
    );
};

export default InstantSearchAllResults;
